import { AfterViewInit, Component, HostListener, inject } from '@angular/core';
import { SocialLinksService } from '../services/social-links.service';
import { AuditService } from '../services/audit.service';
import { TranslocoDirective, TranslocoService } from '@ngneat/transloco';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'cwo-app-banner',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './app-banner.component.html',
  styleUrl: './app-banner.component.scss',
})
export class AppBannerComponent implements AfterViewInit {
  private socialLinksService = inject(SocialLinksService);
  private auditService = inject(AuditService);
  private translocoService = inject(TranslocoService);
  private configService = inject(ConfigService)

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.calculateBannerIndexes();
  }

  storeName = this.configService.configState().store?.name;
  storeLogo = this.configService.configState().store?.logo;
  bannerUrl = this.socialLinksService.bannerUrl();
  appExists = this.socialLinksService.isAppInstalled();

  info = () => this.socialLinksService.socialLinks();

  get isAppleDevice() {
    return this.socialLinksService.isAppleStore();
  }
  
  get appInfo() {
    return {
      name: this.info()?.mobileAppTitle ? this.info()?.mobileAppTitle : this.storeName,
      subtitle: this.info()?.mobileAppDescription ? this.info()?.mobileAppDescription : this.translocoService.translate('component.header.sub_app'),
      icon: this.info()?.mobileAppLogo ? this.info()?.mobileAppLogo : this.storeLogo,
    };
  }

  ngAfterViewInit(): void {
    this.calculateBannerIndexes();
  }

  private calculateBannerIndexes(close:boolean = false) {
    setTimeout(() => {
    const appBanner = document.getElementById('app-banner');
    const topBanner = document.getElementById('top-banner');
    
    const topHeight = topBanner?.clientHeight ?? 0;
    const appHeight = appBanner?.clientHeight ?? 0;

    if (appBanner && !close) {
      document.documentElement.style.setProperty('--top-banner-height', `${appHeight}px`);
      appBanner.style.visibility = 'visible';
      appBanner.style.top = `${topHeight}px`;
      document.documentElement.style.setProperty('--main-header-sticky-top', `${appHeight + topHeight}px`);
    }

    if (close) {
      document.documentElement.style.setProperty('--main-header-sticky-top', `${topHeight - appHeight}px`);
    }
  }, 0);
  }

  dismissBanner() {
    this.socialLinksService.dismissBanner();
    this.calculateBannerIndexes(true);
    this.auditService.createAudit(() => 'Dismiss app banner button clicked.');
  }

  onBannerClick() {
    window.open(this.bannerUrl, '_blank');
    this.auditService.createAudit(() => 'Banner app clicked');
  }

  getButtonText(): string {
    return this.appExists
      ? this.translocoService.translate('component.header.open')
      : this.translocoService.translate('component.header.view');
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    if (!this.storeLogo) {imgElement.style.display='none'}
    else imgElement.src =  this.storeLogo;
  }
}
